<!--footer section -->
<footer class="footer-light">

  <!--  <div class="light-layout">
  <div class="container">
    <section class="small-section border-section border-top-0">
      <div class="row">
        <div class="col-lg-6">
          <div class="subscribe">
            <div>
              <h4>KNOW IT ALL FIRST!</h4>
              <p>Never Miss Anything From Ciaotickets By Signing Up To Our Newsletter. </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <form class="form-inline subscribe-form"
            action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda"
            target="_blank" method="post">
            <div class="form-group mx-sm-3">
              <input type="email" #name name="EMAIL" id="mce-EMAIL" class="form-control"
                placeholder="Enter your email">
              </div>
              <button type="submit" class="btn btn-solid">subscribe</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div> -->
  @if (false) {
    <section class="section-b-space light-layout">
      <div class="container">
        <div class="row footer-theme partition-f">
          <div class="col-lg-4 col-md-6">
            <div class="footer-title footer-mobile-title">
              <h4>about</h4>
            </div>
            <div class="footer-contant">
              <div class="footer-logo">
                <img src="assets/images/logos/logoCT.png" class="img-fluid logo-contain" alt="">
              </div>
              <app-information></app-information>
              <app-social></app-social>
            </div>
          </div>
          <div class="col offset-xl-1">
            <div class="sub-title">
              <!-- <app-categories></app-categories>-->
            </div>
          </div>
          <div class="col">
            <div class="sub-title">
              <!-- <app-why-we-choose></app-why-we-choose>-->
            </div>
          </div>
          <div class="col">
            <div class="sub-title">
              <div class="footer-title">
                <h4>store information</h4>
              </div>
              <div class="footer-contant">
                <ul class="contact-list">
                  <li>
                    <i class="fa fa-map-marker"></i>
                    CIAOTICKETS S.R.L. <br>
                    Via Aldo Moro, 109 <br>
                    65019 Pianella (PE)
                  </li>
                  <li><i class="fa fa-phone"></i>Call Us: +39 085 9720014</li>
                  <li><i class="fa fa-fax"></i>Fax: +39 085 7999342</li>
                  <li class="no-text-transform"><i class="fa fa-envelope-o"></i>Web: <a
                href='https://www.ciaotickets.com/'> www.ciaotickets.com</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}
<div class="sub-footer">
  <div>
    <app-copyright></app-copyright>
  </div>
</div>
</footer>
<!--footer section end -->
<!-- Rtl start -->
<!-- <div class="rtl-btn" id="">
<a href="javascript:void(0)" class="RTL_cls">
  RTL
</a>
</div> -->
<!-- rtl end -->